/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Secondaryemail1Inputs */

const en_settings_secondaryemail1 = /** @type {(inputs: Settings_Secondaryemail1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Secondary Notification email`)
};

/**
* | output |
* | --- |
* | "Secondary Notification email" |
*
* @param {Settings_Secondaryemail1Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const settings_secondaryemail1 = /** @type {((inputs?: Settings_Secondaryemail1Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Secondaryemail1Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_settings_secondaryemail1(inputs)
});
export { settings_secondaryemail1 as "settings_secondaryEmail" }